import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import mobilityHero from "../assets/Hero/mibility_hero.jpg"; // Replace with your hero image
import mdmImage from "../assets/Hero/mobilty.jpg"; // Replace with your MDM image
import intuneImage from "../assets/Hero/mobile-hero.jpg"; // Replace with your Intune image
import "../assets/css/mobilityPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const mobilityData = {
  hero: {
    title: "Mobility Solutions",
    subtitle: "Empower Your Workforce with Mobile Device Management and Microsoft Intune",
  },
  introduction: {
    heading: "Why Mobility Solutions Matter",
    paragraphs: [
      "Mobility solutions enable businesses to securely manage and optimize mobile devices, ensuring productivity and data security.",
      "Our mobility solutions, including Mobile Device Management (MDM) and Microsoft Intune, provide seamless device management, security, and compliance.",
    ],
  },
  solutions: [
    {
      name: "Mobile Device Management (MDM)",
      image: mdmImage,
      description: "MDM allows businesses to manage, secure, and monitor mobile devices across their organization, ensuring compliance and data protection.",
    },
    {
      name: "Microsoft Intune",
      image: intuneImage,
      description: "Microsoft Intune provides cloud-based mobile device management, application management, and PC management for modern workplaces.",
    },
  ],
  cta: {
    heading: "Ready to Optimize Your Mobility Solutions?",
    text: "Contact us today to learn more about our Mobility Solutions and how we can help your business thrive.",
  },
};

export const MobilityPage = ({ data }) => {
  const mobilityRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = mobilityRef.current.querySelectorAll(".mobility-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: mobilityRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="mobility-page" ref={mobilityRef}>
      {/* Hero Section */}
      <div
        className="mobility-hero-section"
        style={{ backgroundImage: `url(${mobilityHero})` }}
      >
        <h1 className="mobility-animate">{mobilityData.hero.title}</h1>
        <p className="mobility-animate">{mobilityData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container mobility-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="mobility-animate">{mobilityData.introduction.heading}</h2>
            {mobilityData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="mobility-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 mobility-image-container">
            <img
              src={mobilityHero}
              className="img-fluid mobility-animate"
              alt="Mobility Solutions"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      </div>

      {/* Solutions Section */}
      <div className="container mobility-solutions-list">
        <div className="row">
          {mobilityData.solutions.map((solution, index) => (
            <div key={index} className="col-md-6 solution-card mobility-animate">
              <img
                src={solution.image}
                className="img-fluid solution-image"
                alt={solution.name}
              />
              <h3>{solution.name}</h3>
              <p>{solution.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container mobility-cta">
        <h2 className="mobility-animate">{mobilityData.cta.heading}</h2>
        <p className="mobility-animate">{mobilityData.cta.text}</p>
        <button
          className="btn btn-primary mobility-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};

